import { addDays, endOfMonth, startOfMonth, subDays, subMonths, subYears } from 'date-fns';

export default {
  computed: {
    quickDates() {
      return [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_30_days'),
          value: {
            type: 'picker',
            range: [subDays(new Date(), 29), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.this_month'),
          value: {
            type: 'picker',
            range: [startOfMonth(new Date()), endOfMonth(new Date())],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.previous_month'),
          value: {
            type: 'picker',
            range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_90_days'),
          value: {
            type: 'picker',
            range: [subDays(new Date(), 89), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_1_year'),
          value: {
            type: 'picker',
            range: [addDays(subYears(new Date(), 1), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
    pickerReportOptions() {
      return  [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.this_month_so_far'),
          value: {
            type: 'picker',
            short_title: 'this_month_so_far',
            range: [startOfMonth(new Date()), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.previous_month'),
          value: {
            type: 'picker',
            short_title: 'previous_month',
            range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_30_days'),
          value: {
            type: 'picker',
            short_title: 'last_30_days',
            range: [subDays(new Date(), 29), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_90_days'),
          value: {
            type: 'picker',
            short_title: 'last_90_days',
            range: [subDays(new Date(), 89), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_6_months'),
          value: {
            type: 'picker',
            short_title: 'last_6_months',
            range: [addDays(subMonths(new Date(), 6), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_1_year'),
          value: {
            type: 'picker',
            short_title: 'last_1_year',
            range: [addDays(subYears(new Date(), 1), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
  },
  methods: {
    getQuickDates() {
      return [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_30_days'),
          value: {
            type: 'picker',
            range: [subDays(new Date(), 29), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.this_month'),
          value: {
            type: 'picker',
            range: [startOfMonth(new Date()), endOfMonth(new Date())],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.previous_month'),
          value: {
            type: 'picker',
            range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_90_days'),
          value: {
            type: 'picker',
            range: [subDays(new Date(), 89), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_1_year'),
          value: {
            type: 'picker',
            range: [addDays(subYears(new Date(), 1), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
    getPickerReportOptions() {
      return [
        {
          label: this.$t('ui.shortcuts.relative_time_ranges'),
          value: {
            short_title: 'group',
            type: 'group-title',
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.this_month_so_far'),
          value: {
            type: 'picker',
            short_title: 'this_month_so_far',
            range: [startOfMonth(new Date()), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.previous_month'),
          value: {
            type: 'picker',
            short_title: 'previous_month',
            range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_30_days'),
          value: {
            type: 'picker',
            short_title: 'last_30_days',
            range: [subDays(new Date(), 29), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_90_days'),
          value: {
            type: 'picker',
            short_title: 'last_90_days',
            range: [subDays(new Date(), 89), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_6_months'),
          value: {
            type: 'picker',
            short_title: 'last_6_months',
            range: [addDays(subMonths(new Date(), 6), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
        {
          label: this.$t('ui.shortcuts.last_1_year'),
          value: {
            type: 'picker',
            short_title: 'last_1_year',
            range: [addDays(subYears(new Date(), 1), 1), new Date()],
          },
          slot: 'preset-date-range-button',
        },
      ];
    },
    checkPeriod({ datePeriod, dateRange }) {
      const curPeriod = datePeriod && this.getPickerReportOptions().find((el) => el.value.short_title === datePeriod);
      if (curPeriod) {
        return {
          datePeriod,
          dateRange: curPeriod.value.range,
        };
      }

      return {
        datePeriod: null,
        dateRange,
      };
    },
  },
};
